
import { useState, useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/contexts/AuthContext";
import { Board } from "@/contexts/boards/types";

export const useBoard = (boardId?: string) => {
  const { user } = useAuth();
  const [board, setBoard] = useState<Board | null>(null);

  const { data: boardData, isLoading } = useQuery({
    queryKey: ["board", boardId],
    queryFn: async () => {
      if (!boardId || !user) return null;

      try {
        const { data, error } = await supabase
          .from("boards")
          .select("*")
          .eq("id", boardId)
          .eq("user_id", user.id)
          .single();

        if (error) {
          console.error("Error fetching board:", error);
          return null;
        }

        return data as Board;
      } catch (error) {
        console.error("Error in fetchBoard:", error);
        return null;
      }
    },
    enabled: !!boardId && !!user
  });

  useEffect(() => {
    if (boardData) {
      setBoard(boardData);
    }
  }, [boardData]);

  return { board, isLoading };
};
